<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <!-- SI ES SUPERVISOR NO DEBE MOSTRAR FILTRO DE ESTRUCTURAS -->
                    <b-col align-h="center" cols="12" md="4" lg="3" v-if="!isSupervisor">
                        <app-form-select-input placeholder="Estructura" :options="accessPoints" v-model="filters.structure"></app-form-select-input>
                    </b-col>
                    <b-col cols="12" md="4" lg="3">
                        <app-autocomplete
                            placeholder="Creador"
                            :items="authors"
                            v-model="selectUser"
                        /> 
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../../components/UI/Controls/AutocompleteV2/Autocomplete.vue';
import structuresRepository from '../../../../repositories/structures.repository.js';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        authors: {
            type: Array
        },
        accessPoints: {
            type: Array,
            required: true
        }
    },
    data(){
        return {
            isSupervisor: false,
            filters: {
                structure: '',
                user: '',
                client: ''
            },
            selectUser: ''
        }
    },
    watch:{
        selectUser(val){
            if(!val){
                this.filters.user = '';
                this.selectUser = '';
            }else{
                this.filters.user = val.id;
            }
        }
    },
    methods: {
        clearFilters(){
            this.selectUser = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    created(){
        this.isSupervisor = this.user.profile.slug === 'supervisor' ? true: false;
    }
}
</script>

